import { z } from "zod";
import type { PaginatedData } from "@core/types/TApiResponse";

export const UserWorkspaceSchema = z.object({
  id: z.string(),
  name: z.string(),
  logo: z.string().nullable(),
  industry: z.string(),
  company: z.string(),
  description: z.string().nullable(),
  status: z
    .enum([
      "active",
      "suspended",
      "pending",
      "expired",
      "grace_period",
      "archived",
    ])
    .catch("active"),
  role: z.enum(["admin", "member"]).catch("member"),
  is_user_suspended: z.boolean(),
});

export type TUserWorkspace = z.infer<typeof UserWorkspaceSchema>;

export type UserWorkspacesData = PaginatedData<TUserWorkspace>;
